import React, { useState } from 'react';
import { DialogActions, Typography } from '@mui/material';
import { DialogContent } from '@mui/material';
import { DialogTitle } from '@mui/material';
import { Dialog } from '@mui/material';
import { showAlert } from '../../../../../../../lib/functions/utils';
import { useDispatch } from 'react-redux';
import { deleteRelatedBusiness } from '../../../../../../../lib/api/business';
import CustomButton from '../../../../../../../lib/designSystem/Button';
import CenteredCircularProgress from '../../../../../../../lib/designSystem/CircularProgress';
interface ConfirmDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  businessToIdentifier: string;
  businessFromIdentifier: string;
}

const ConfirmDeleteDialog = ({
  open,
  onClose,
  businessToIdentifier,
  businessFromIdentifier,
}: ConfirmDeleteDialogProps) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const handleConfirm = async () => {
    try {
      setLoading(true);
      const response = await deleteRelatedBusiness(
        dispatch,
        businessFromIdentifier,
        businessToIdentifier,
      );
      if (response) {
        showAlert(dispatch, 'success', 'Empresa eliminada correctamente');
        onClose();
      }
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al eliminar la empresa');
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmar eliminación</DialogTitle>
      {loading && <CenteredCircularProgress relative />}
      {!loading && (
        <div>
          <DialogContent>
            <Typography>
              ¿Estás seguro de querer eliminar la relación con la empresa{' '}
              {businessToIdentifier} a la empresa {businessFromIdentifier}?
            </Typography>
          </DialogContent>
          <DialogActions>
            <CustomButton onClick={onClose} color="secondary">
              Cancelar
            </CustomButton>
            <CustomButton onClick={handleConfirm} color="error">
              Confirmar
            </CustomButton>
          </DialogActions>
        </div>
      )}
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
